import { getUserInfo } from "../../services/localStorage";
import { getUserDetails } from "../../services/authService";

export function buildLdsOrdersGuardCtx(agentEntitlements) {
  return {
    selectors: {
      canSearchFlights: agentEntitlements.canSearchFlights,
      canSearchPackages: agentEntitlements.canSearchPackages,
      canUseDynamicPackages: agentEntitlements.canUseDynamicPackages,
      canOrganizedTours: agentEntitlements.canOrganizedTours,
      canSearchHotels: agentEntitlements.canSearchHotels,
    },
    entitlementsStatus: agentEntitlements.status,
    userId: getUserInfo()?.id ?? null,
    role: String(getUserDetails()?.role ?? "").trim() || null,
  };
}
